import { toast } from "react-toastify";
import { useEffect, useState } from "react";

import { Deal } from "@Types/deal";
import Select from "@Components/Select";
import Button from "@Components/Button";
import Loading from "@Components/Loading";
import { TitleIssue } from "@Types/title_issues";
import { useForceTitleIssueCheck } from "@Hooks/useTitleIssues";

import styles from "./DmvInfo.module.scss";
import { SupportedStates } from "./DmvInfo";

export default function DMVDialog({
  open,
  deal,
  setOpen,
  titleIssue,
  currentState,
}: {
  deal: Deal;
  open: boolean;
  titleIssue: TitleIssue;
  currentState: string | null;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const handleHideDialog = () => {
    setOpen(false);
  };

  const { forceTitleIssueCheck, loading, success } =
    useForceTitleIssueCheck(deal);
  const [state, setState] = useState<string | null>(currentState);

  const handleForceTitleIssueCheck = () => {
    if (state) {
      forceTitleIssueCheck({
        ...titleIssue,
        data: { ...titleIssue?.data, deal },
        state,
      });
    } else {
      toast.error("Please select a valid DMV.", {
        position: "top-center",
      });
    }
  };

  useEffect(() => {
    if (success) {
      toast.success("Successfully performed a dmv check.", {
        position: "top-center",
      });
      handleHideDialog();
    }
  }, [success]);

  return open ? (
    <>
      <dialog
        id="close-dialog"
        data-testid="dialog"
        className={styles.closeDialogContainer}
        open={true}
      >
        <div className={styles.closeDialogContent}>
          <div className={styles.header}>Select DMV</div>
          {loading ? (
            <div className={styles.loading}>
              <Loading />
            </div>
          ) : (
            <Select
              required
              placeholder="DMV"
              name="DMV"
              id="state"
              onChange={(e) => setState(e.target.value)}
              value={state || undefined}
              options={SupportedStates.map((state) => ({
                label: state,
                value: state,
              }))}
            />
          )}
        </div>
        <div className={styles.closeDialogButtons}>
          <Button
            className={styles.closeDialogButton}
            onClick={() => {
              handleHideDialog();
            }}
            variant="pink"
          >
            Close
          </Button>
          <Button
            className={styles.closeDialogButton}
            onClick={() => {
              handleForceTitleIssueCheck();
            }}
            variant="blue"
          >
            Perform DMV Check
          </Button>
        </div>
      </dialog>
    </>
  ) : null;
}
